import type { CountdownProps } from '@builder4/shared/components/Countdown';
import { SliderField } from './SliderField';
import { useNode } from '@craftjs/core';
import { useBreakpointAwareProp } from '@/hooks/useBreakpointAwareProp';

interface NodeCountdownSizeSettingsProps {
  text?: string;
  type: 'number' | 'label';
}

const NodeCountdownSizeSettings = ({
  text = 'Text Size',
  type = 'number',
}: NodeCountdownSizeSettingsProps) => {
  const {
    props,
    displayName,
    actions: { setProp },
  } = useNode((node) => ({
    id: node.id,
    props: node.data.props,
    displayName: node.data.displayName,
  }));

  const { setBPProp, getBPProp } = useBreakpointAwareProp(displayName);

  const numberFontSize = getBPProp(props, 'numberFontSize');
  const labelFontSize = getBPProp(props, 'labelFontSize');

  const getFontSize = () => {
    const finalFontSize =
      type === 'number'
        ? parseInt(numberFontSize?.replace?.('px', '') || '0', 10)
        : parseInt(labelFontSize?.replace?.('px', '') || '0', 10);
    return finalFontSize;
  };

  const handleOnChange = (value: number) => {
    setProp((props: CountdownProps) => {
      if (type === 'number') {
        setBPProp(props, 'numberFontSize', `${value}px`);
      } else {
        setBPProp(props, 'labelFontSize', `${value}px`);
      }
    }, 500);
  };

  return (
    <SliderField
      label={text}
      value={getFontSize()}
      onChange={handleOnChange}
      onChangeComplete={handleOnChange}
      min={0}
      max={100}
    />
  );
};

export default NodeCountdownSizeSettings;
